<app-background backgroundImage="images/shared/backgrounds/background-1.avif">
    <h1 class="sr-only">App Marketing Services — ASO, User Acquisition, Influencer, and Retention</h1>
    <app-hero-section
        [backgroundImage]="`images/${file}/backgrounds/${file}.avif`" videoSrc="/video/marketing-services.mp4"
        align="left" [titleHtml]="heroTitleHtml"
        subcopy="From strategy to scale, we grow your app's downloads, retention, and revenue with ASO, paid user acquisition, influencer marketing, and conversion optimization."
        text="service">
        <app-button hero-cta buttonText="get in touch now!" (clicked)="scheduleCall()"></app-button>
    </app-hero-section>
    <app-lead-section [section]="introA"></app-lead-section>
    <hr appReveal class="section-divider" />
    <app-tag-services [section]="asoSection" marker="check"></app-tag-services>
</app-background>
<app-background backgroundImage="images/shared/backgrounds/background-2.avif">
    <div class="w-full pt-[40px] mb-[60px] px-4 sm:px-[10%]">
      <div class="glass-cta-wrap max-w-[900px] mx-auto">
        <div appReveal appSpotlight class="glass-cta-card r-rise rounded-[28px] p-8 sm:p-12 flex flex-col items-center text-center">
            <div class="font-inter mb-7 text-sm sm:text-base max-w-[640px]">
                SEM Nexus is an award-winning agency specializing in building and marketing mobile apps. They offer a
                comprehensive suite of services designed to help startups and established businesses succeed in the
                mobile app industry.<br><br>
                Increase App Downloads, Improve User Retention &amp; Drive Revenue! Contact us today for a <span
                    class="gradient-text">FREE mobile app marketing consultation</span>.
            </div>
            <app-button buttonText="get in touch now!" (clicked)="scheduleCall()"></app-button>
        </div>
      </div>
    </div>
    <hr appReveal class="section-divider" />
    <app-tag-services [section]="userAcquisitionSection" marker="check"></app-tag-services>
    <hr appReveal class="section-divider" />
    <app-dev-services [section]="advertisingSection" [cards]="adCards"></app-dev-services>
    <hr appReveal class="section-divider" />
    <app-icon-section [section]="influencerSection" iconSide="left"
        icon="images/marketing-services/platform/influencer.png"></app-icon-section>
</app-background>
<app-background backgroundImage="images/shared/backgrounds/background-3.avif">
    <hr appReveal class="section-divider" />
    <app-tag-services [section]="croSection" marker="check"></app-tag-services>
    <hr appReveal class="section-divider" />
    <app-steps-section [section]="retentionSection"></app-steps-section>
    <hr appReveal class="section-divider" />
    <app-lead-section [section]="whyChooseSection" layout="center"></app-lead-section>
    <div class="h-[60px]"></div>
    <app-connect></app-connect>
</app-background>
